import { FC } from "react";
import { Modal, Button } from "react-bootstrap";
import style from "./style.module.scss";

export type ModalProps = {
  show: boolean;
  name: string;
  text: string;
  handleCancel: () => void;
  handleConfirm: () => void;
};
export const ConfirmDeleteModal: FC<ModalProps> = (props) => {
  const { show, name, text, handleCancel, handleConfirm } = props;

  return (
    <Modal show={show} centered>
      <Modal.Body>
        <div className="d-flex flex-column align-items-center gap-3">
          <i className={`bi bi-trash3 text-light ${style.icon}`}></i>
          <h6 className={style.name}>{`Elimina ${name}`}</h6>
          <h6 className={style.question}>{text}</h6>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center align-items-center border-top-0">
        <Button
          variant="outline-light px-4 rounded-1"
          onClick={handleCancel}
          className={style.button}
        >
          Annulla
        </Button>
        <Button
          variant="secondary text-white px-4 rounded-1"
          onClick={handleConfirm}
          className={style.button}
        >
          ELIMINA
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
